/* global axios */
import ApiClient from '../ApiClient';
import { isEnterpriseEnabled } from 'dashboard/helper/enterpriseFlag';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  subscription() {
    return axios.post(`${this.url}subscription`);
  }

  getLimits(accountId) {
    if (!isEnterpriseEnabled() || !accountId) {
      return Promise.resolve({ data: { limits: null } });
    }
    return axios.get(`${this.url}limits`);
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits) {
    return axios.post(`${this.url}topup_checkout`, { credits });
  }
}

export default new EnterpriseAccountAPI();
